import { Injectable } from '@angular/core';
import { StaticReferences } from './staticReference.model';

@Injectable()
export class ReferenceService {
    public staticReferences: StaticReferences;
    constructor() {
        this.staticReferences = new StaticReferences();
    }
}
